<template>
  <div ref="body">
    <div
      v-if="table.response.data == null || table.response.data.length === 0"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        color: #a1a1a1;
        height: 100%;
      "
    >
      이미지가 없습니다
    </div>
    <div
      ref="viewer"
      :class="table.response.data != null && table.response.data.length > 0 ? '' : 'd-none'"
      style="padding: 0 10px 0 10px"
    >
      <div style="position: absolute; left: -10px; top: 50%; z-index: 100">
        <button class="btn" v-if="view.leftScrollButton" @click="moveGallery('left')">
          <i class="fa fa-chevron-left fa-2x" aria-hidden="true" style="color: #52bcff"></i>
        </button>
      </div>
      <div style="position: absolute; right: -5px; top: 50%; z-index: 100">
        <button class="btn" v-if="view.rightScrollButton" @click="moveGallery('right')">
          <i class="fa fa-chevron-right fa-2x" aria-hidden="true" style="color: #52bcff"></i>
        </button>
      </div>
      <perfect-scrollbar
        ref="gallery"
        @ps-scroll-x="onScroll"
        :options="{
          suppressScrollY: true,
          useBothWheelAxes: true,
        }"
        :class="isMobile ? 'hidden' : ''"
      >
        <div class="d-flex">
          <div
            v-for="(item, index) in table.response.data"
            :key="index"
            class="image-card text-center border-0"
          >
            <div style="height: 30px; line-height: 30px">
              {{ getDate(item.createdAt) }}
            </div>
            <img
              :src="item.thumbImageUrl"
              :data-src="item.imageUrl"
              :style="{
                width: imageWidth + 'px',
                height: '210px',
                'object-fit': 'cover',
                cursor: 'pointer',
              }"
              :alt="item.id"
              @click="selectImage(item)"
            />
            <div class="pt-2">
              <div class="label bg-color-gray-dark scc-rounded">
                {{ getAddress(item) }}
              </div>
              <div>
                {{ getDiseaseName(item) }}
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import DiseaseService from "@/services/disease/disease.service";
import core from "@/core";

export default {
  name: "DiseaseAreaGalleryComponent",
  components: {},
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          searchColumns: {
            status: "UNKNOWN",
          },
          event: null,
          callback: null,
        };
      },
    },
  },
  data() {
    return {
      isMobile: false,
      ready: false,
      imageWidth: 250,
      view: {
        leftScrollButton: false,
        rightScrollButton: false,
      },
      updateViewType: null,
      table: {
        event: {
          reloadFlag: false,
          nextLoadFlag: false,
        },
        request: {
          draw: 0,
          start: 0,
          length: 6,
          orderColumnName: "id",
          order: "desc",
          searchColumns: {},
        },
        response: {
          draw: 0,
          recordsFiltered: 0,
          recordsTotal: 0,
          data: [],
        },
      },
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.ready = true;
      this.table.event.reloadFlag = true;
      const platform = core.utils.platform();
      if (platform === "android" || platform === "ios") {
        this.isMobile = true;
      }
      this.resizeEvent();
      window.addEventListener("resize", this.resizeEvent);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEvent);
  },
  watch: {
    "properties.searchColumns"(searchColumns) {
      // console.log("changed searchColumns : ", searchColumns);
      this.reloadTable();
    },
    "properties.event"(event) {
      this.properties.event = null;
      if (event != null) {
        if (event.type === "DELETE") {
          const item = event.item;
          this.table.response.data.some((data, index) => {
            if (item.id === data.id) {
              this.table.response.data.splice(index, 1);
              this.table.response.recordsTotal = this.table.response.recordsTotal - 1;
              return true;
            }
          });
        }
      }
      // console.log("changed searchColumns : ", searchColumns);
      this.reloadTable();
    },
    "table.event.reloadFlag"(reloadFlag) {
      if (reloadFlag) {
        this.table.event.reloadFlag = false;
        if (this.ready) {
          const searchColumns = this.properties.searchColumns;
          if (searchColumns != null) {
            this.getTableList(searchColumns);
          }
        }
      }
    },
    "table.event.nextLoadFlag"() {
      if (this.table.event.nextLoadFlag) {
        if (this.ready) {
          const searchColumns = this.properties.searchColumns;
          if (searchColumns != null) {
            this.getTableList(searchColumns);
          }
        }
      }
    },
  },
  updated() {
    const updateViewType = this.updateViewType;
    this.updateViewType = null;
    if (updateViewType === "table") {
      this.onScroll();
    }
  },
  methods: {
    resizeEvent() {
      const el = this.$refs.body;
      const parentEl = el.parentElement;
      el.style.width = parentEl.clientWidth - 40 + "px";
    },
    selectImage(item) {
      //console.log("select : ", item);
      this.properties.callback = {
        item: item,
      };
    },
    getAddress(item) {
      if (item.sidoName != null && item.sggName != null) {
        return item.sidoName + " " + item.sggName;
      }
      return "지역 정보 없음";
    },
    getDate(at) {
      if (core.utils.validate.isBlank(at)) {
        return "";
      }
      return core.date.instance(at).format("YYYY년 MM월 DD일(ddd)");
    },
    getDiseaseName(item) {
      if (item.analysisResultList != null) {
        if (item.analysisResultList.length > 0) {
          return item.analysisResultList[0].name;
        }
      } else if (item.annotations != null) {
        if (item.annotations.length > 0) {
          return item.annotations[0].name;
        }
      }
      return "판독필요";
    },
    onScroll() {
      const element = this.$refs["gallery"];
      const $el = element.$el;
      const scrollWidth = $el.scrollWidth;
      const clientWidth = $el.clientWidth;
      const width = scrollWidth - clientWidth;
      const scrollLeft = Math.ceil($el.scrollLeft);

      // console.log(`width : ${width}, scrollLeft : ${scrollLeft}`);

      // console.log("horizontal : ", horizontal);
      if (scrollLeft === 0) {
        this.view.leftScrollButton = false;
        if (width === 0) {
          this.view.rightScrollButton = false;
        } else {
          this.view.rightScrollButton = true;
        }
      } else if (scrollLeft === width) {
        this.view.leftScrollButton = true;
        this.view.rightScrollButton = false;
        const table = this.table;
        if (!table.event.nextLoadFlag && table.request.start < table.response.recordsTotal) {
          this.table.event.nextLoadFlag = true;
        }

        // 테이블 정보 요청
      } else {
        this.view.leftScrollButton = true;
        this.view.rightScrollButton = true;
      }
    },
    moveGallery(direction) {
      const element = this.$refs["gallery"];
      const $el = element.$el;
      const scrollWidth = $el.scrollWidth;
      const clientWidth = $el.clientWidth;
      const width = scrollWidth - clientWidth;
      const scrollLeft = $el.scrollLeft;
      const imageWidth = this.imageWidth + 20;

      const imageCount = Math.ceil(scrollLeft / imageWidth) + (direction === "right" ? 1 : -1);
      //console.log("imageCount : ", imageCount);

      let x = imageCount * imageWidth;
      if (x < 0) x = 0;
      else if (x > width) x = width;
      $el.scrollLeft = x;
    },

    getAnalysisInfoUrl(analysisResult) {
      return DiseaseService.getInfoUrl(analysisResult.name, analysisResult.similarity);
    },

    reloadTable() {
      const table = this.table;
      table.event.reloadFlag = true;
      table.request.start = 0;
      table.response.data = [];
      table.response.recordsFiltered = 0;
      table.response.recordsTotal = 0;
      table.response.draw = 0;
      const element = this.$refs["gallery"];
      const $el = element.$el;
      $el.scrollLeft = 0;
    },

    async getTableList(searchColumns) {
      core.loader.show("데이터 요청중...");
      const params = this.table.request;
      params.searchColumns = searchColumns;
      searchColumns.status = "UNKNOWN";

      const response = await DiseaseService.getTableList(params);
      response.data.forEach((data) => {
        this.table.response.data.push(data);
      });
      this.table.response.recordsFiltered = response.recordsFiltered;
      this.table.response.recordsTotal = response.recordsTotal;
      this.table.response.draw = response.draw;

      this.table.request.start = this.table.response.data.length;
      this.updateViewType = "table";
      this.table.event.nextLoadFlag = false;

      core.loader.hide();
    },
  },
};
</script>

<style>
.hidden .ps__rail-x {
  display: none;
}

.hidden .ps__rail-y {
  display: none;
}
</style>
